<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">
      <a [routerLink]="['/dash/api']" *ngIf="userData.level <= 3">API</a>
      <span *ngIf="userData.level <= 3"> /</span> Logs</p>
      <h2 class="">API Logs</h2>
  </div>
</div>

<div class="content-block">
  <div class="dx-card responsive-paddings">
    <div>* Solo se muestran los LOGS de las peticiones a CacaoPayworks</div>
    <!-- Filters-->
    <div class="flex flex-nowrap flex-space-between align-items-center">
      <dx-form [(formData)]="filters" [colCount]="5" labelLocation="top" style="width: 100%">
    
        <!-- Method -->
        <dxi-item dataField="method" dataType="string" [isRequired]="false">
          <dxo-label text="Método Cacao"></dxo-label>
          <dx-select-box [(value)]="filters.method" [dataSource]="methods" displayExpr="name" valueExpr="name">
            <dx-validator>
              <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </dxi-item> 
        
        <!-- Method -->
        <!-- cardNumber -->
        <dxi-item dataField="cardNumber" [editorOptions]="cardNumberEditorOptions">
          <dxo-label text="Tarjeta"></dxo-label>
        </dxi-item>  
        
        <!-- Date Start -->
          <dxi-item dataField="dateStart" dataType="date" [isRequired]="false">
            <dxo-label text="Fecha Inicio"></dxo-label>
            <dx-date-box displayFormat="shortdate" type="date" [(value)]="filters.dateStart" (onValueChanged)="getLogsCacao($event)">
              <dx-validator>
                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-date-box>
          </dxi-item>

          <!-- Date End -->
          <dxi-item dataField="dateEnd" dataType="date" [isRequired]="false">
            <dxo-label text="Fecha Fin"></dxo-label>
            <dx-date-box displayFormat="shortdate" type="date" [(value)]="filters.dateEnd" (onValueChanged)="getLogsCacao($event)">
              <dx-validator>
                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-date-box>
          </dxi-item>

      </dx-form>
      <div class="">
        <dx-button text="Buscar" icon="find" type="default" (onClick)="getLogsCacao()"></dx-button>  
      </div>
    </div>

    <!-- DataGrid -->
    <dx-data-grid 
      [dataSource]="logs" 
      keyExpr="idCacaoLog" 
      [showBorders]="true"
      [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }">

        <!-- DataGrid -> Pagging-->
        <dxo-paging [pageIndex]="pagination.page" [pageSize]="pagination.pageSize"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="pagination.pageSizeOptions" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>

        <!-- DataGrid -> LoadPanel -->
        <dxo-load-panel [enabled]="true"></dxo-load-panel>

        <!-- DataGrid -> Columns -->
        <dxi-column dataField="method" caption="Método"></dxi-column>
        <dxi-column dataField="CodRespuesta" caption="Código"></dxi-column>
        <dxi-column dataField="DescRespuesta" caption="Respuesta"></dxi-column>
        <dxi-column dataField="dateCreated" caption="Fecha" dataType="date" format="dd-MM-yyyy hh:mm a"></dxi-column>
      
        
        <div *dxTemplate="let log of 'detail'" style="padding:0">
          <div class="flex flex-nowrap flex-space-between">
            <div>
              <ul>
                
                <li>URL:  {{ log.data.url }}</li>
                <li>ENV:  {{ log.data.enviroment }}</li>
                <li>IP:   {{ log.data.ip }}</li>
              </ul>
            </div>
            <div>
              <div>Body:</div>
              <div>
                String: 
                <div>{{ log.data.body | json }}</div>
              </div>
              <div>
                JSON:
                <div *ngFor="let item of log.data.body| keyvalue">
                  {{ item.key }}: {{ item.value }}
                </div>
              </div>
              
            </div>
          </div>
        </div>
    </dx-data-grid>
  </div>
</div>